import React from "react";
import "../App.css";
import { buildApiUrl } from "../config/api";
import { getTournamentVoterId } from "../utils/tournament";

function TournamentPage() {
  const [data, setData] = React.useState(null);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [status, setStatus] = React.useState({ type: "", text: "" });
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const loadTournament = React.useCallback(async () => {
    const response = await fetch(buildApiUrl("/api/tournament/public"), {
      headers: {
        "Content-Type": "application/json",
        "x-voter-id": getTournamentVoterId(),
      },
    });
    const result = await response.json();
    setData(result);
  }, []);

  React.useEffect(() => {
    loadTournament().catch((error) => {
      setStatus({ type: "error", text: error.message });
    });
  }, [loadTournament]);

  if (!data?.tournament) {
    return <div className="tournament-page">Завантаження турніру...</div>;
  }

  const { tournament, existingVote } = data;
  const participants = tournament.participants || [];
  const activeParticipant = participants[activeIndex] || participants[0];
  const activeImage = activeParticipant?.imageData || activeParticipant?.imageUrl;

  const vote = async () => {
    if (!activeParticipant || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(buildApiUrl("/api/tournament/vote"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-voter-id": getTournamentVoterId(),
        },
        body: JSON.stringify({ participantId: activeParticipant.id }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || "Не вдалося зарахувати голос");
      }

      setStatus({
        type: "success",
        text: `Ваш голос за ${result.participant.name} зараховано`,
      });
      await loadTournament();
    } catch (error) {
      setStatus({ type: "error", text: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="tournament-page">
      <section className="tournament-hero">
        <div>
          <div className="hero-kicker">Турнір</div>
          <h1>{tournament.title}</h1>
          <p>{tournament.description}</p>
        </div>
        <div className="tournament-hero-meta">
          <div>
            <span>Статус</span>
            <strong>{tournament.allowVoting ? "Голосування відкрите" : "Голосування закрите"}</strong>
          </div>
          <div>
            <span>Учасників</span>
            <strong>{participants.length}</strong>
          </div>
          <div>
            <span>Ваш голос</span>
            <strong>{existingVote ? "Вже зараховано" : "Ще не подано"}</strong>
          </div>
        </div>
      </section>

      <section className="tournament-layout">
        <div className="tournament-slider-card">
          <div className="tournament-slider-image">
            {activeImage ? (
              <img src={activeImage} alt={activeParticipant.name} />
            ) : (
              <div className="tournament-image-placeholder">Додайте фото в адмінці</div>
            )}
          </div>

          <div className="tournament-slider-copy">
            <div className="tournament-badge">{activeParticipant?.subtitle || tournament.subtitle}</div>
            <h2>{activeParticipant?.name}</h2>
            <p>{activeParticipant?.description || "Опис учасника з’явиться після налаштування."}</p>

            <div className="tournament-vote-row">
              <button
                type="button"
                className="button"
                onClick={vote}
                disabled={!tournament.allowVoting || Boolean(existingVote) || isSubmitting}
              >
                {existingVote ? "Голос уже подано" : "Проголосувати за учасника"}
              </button>
              <div className="tournament-votes-count">
                Голосів: <strong>{activeParticipant?.votes || 0}</strong>
              </div>
            </div>
          </div>
        </div>

        <div className="tournament-sidebar">
          <div className="tournament-nav">
            {participants.map((participant, index) => (
              <button
                key={participant.id}
                type="button"
                className={index === activeIndex ? "selected" : ""}
                onClick={() => setActiveIndex(index)}
              >
                <span>{participant.name}</span>
                <strong>{participant.votes || 0}</strong>
              </button>
            ))}
          </div>

          {status.text ? (
            <div className={`tournament-alert ${status.type}`}>
              {status.text}
            </div>
          ) : null}

          <div className="tournament-note">
            Один пристрій може віддати лише один голос. З одного
            інтернет-з'єднання дозволено кілька голосів у межах базового ліміту,
            щоб один Wi-Fi не блокував усіх повністю.
          </div>
        </div>
      </section>
    </div>
  );
}

export default TournamentPage;
